import type { ReaderAiThreadSummary } from "@/types/agentic-chat";

export const coerceThreadSummary = (
  summary?: Partial<ReaderAiThreadSummary> | null,
): ReaderAiThreadSummary | null => {
  if (!summary?.threadId || typeof summary.threadId !== "string") return null;
  return {
    threadId: summary.threadId,
    rollingSummary: typeof summary.rollingSummary === "string" ? summary.rollingSummary.trim() : "",
    activeGoals: Array.isArray(summary.activeGoals) ? summary.activeGoals.map((item) => String(item).trim()).filter(Boolean) : [],
    openLoops: Array.isArray(summary.openLoops) ? summary.openLoops.map((item) => String(item).trim()).filter(Boolean) : [],
    lastUpdatedAt: typeof summary.lastUpdatedAt === "number" ? summary.lastUpdatedAt : Date.now(),
    summaryVersion: typeof summary.summaryVersion === "number" ? summary.summaryVersion : 1,
  };
};

export const hasMeaningfulThreadSummary = (summary?: Partial<ReaderAiThreadSummary> | null) => {
  const normalized = coerceThreadSummary(summary);
  return Boolean(normalized && (normalized.rollingSummary || normalized.activeGoals.length || normalized.openLoops.length));
};
